import { CircularProgress } from "@material-ui/core"
import { withStyles } from "@material-ui/core/styles"
import { getEventDonations } from "actions/event"
import ShoutoutCard from "components/ShoutoutCard"
import { subscribe } from "pubsub-js"
import React, { Component, createRef } from "react"
import { connect } from "react-redux"
import { compose } from "recompose"
import { ADMIN_EVENT } from "types/pubsub"
import styles from "./styles"

class Shoutout extends Component {
  componentDidMount() {
    if (this.props.data.name === "ScrollingShoutouts") {
      if (this.props.data.settings.events.includes("show_previous")) {
        this.setState({ previousLoading: true })
        this.props
          .dispatch(getEventDonations(this.props.event.auction_code))
          .then(res => {
            this.setState(
              {
                shoutouts: [...res],
                previousLoading: false
              },
              () => {
                this.measureHeight()
                if (res.length >= 9) this.startCycleInterval()
              }
            )
          })
      }

      this.props.data.settings.events.forEach(setting => {
        const eventMap = {
          donation_pledges: `${ADMIN_EVENT}::addDonation`,
          raffle_purchase_earnings: `${ADMIN_EVENT}::rafflePurchase`,
          bid_earnings: `${ADMIN_EVENT}::highBid`,
          fixed_purchase_earnings: `${ADMIN_EVENT}::fixedPurchase`,
          raffle_winners: `${ADMIN_EVENT}::drawRaffle`
        }
        if (eventMap[setting]) {
          subscribe(eventMap[setting], this.handleShoutOut)
        }
      })

      this.setState({ nameStyle: this.props.data.settings.name_style })
    }
  }

  componentWillUnmount() {
    clearInterval(this.cycleInterval)
  }
  marqueeRef = createRef()
  innerRef = createRef()
  viewportRef = createRef()
  itemHeight = 100 // fallback, will be measured

  state = {
    shoutouts: [],
    nameStyle: "full_name",
    previousLoading: false,
    animating: false
  }

  measureHeight = () => {
    const firstItem = this.innerRef.current && this.innerRef.current.firstChild
    if (firstItem) {
      this.itemHeight = firstItem.getBoundingClientRect().height

      // Set height of the visible container to show exactly 8 items
      if (this.viewportRef.current) {
        this.viewportRef.current.style.height = `${this.itemHeight * 8}px`
      }
    }
  }

  startCycleInterval = () => {
    this.cycleInterval = setInterval(() => {
      this.setState({ animating: true }, this.animateScroll)
    }, 2150)
  }

  animateScroll = () => {
    const el = this.marqueeRef.current
    if (!el) return

    el.style.transition = "transform 0.75s ease-in-out"
    el.style.transform = `translateY(-${this.itemHeight}px)`

    setTimeout(this.rotateShoutouts, 750)
  }

  rotateShoutouts = () => {
    this.setState(prevState => {
      const updated = [...prevState.shoutouts]
      const first = updated.shift()

      // Clear isNew after one full cycle
      if (first.isNew) {
        first.isNew = false
      }

      updated.push(first)

      return {
        shoutouts: updated,
        animating: false
      }
    }, this.resetScrollTransform)
  }

  resetScrollTransform = () => {
    const el = this.marqueeRef.current
    if (el) {
      el.style.transition = "none"
      el.style.transform = "translateY(0px)"
    }
  }

  handleShoutOut = (msg, data) => {
    data.isNew = true
    data.none = ""
    this.setState(prev => {
      const updated = [...prev.shoutouts, data]
      if (updated.length === 9 && !this.cycleInterval) {
        this.measureHeight()
        this.startCycleInterval()
      }
      return { shoutouts: updated }
    })
  }

  render() {
    const { classes } = this.props
    const { previousLoading, shoutouts } = this.state

    return (
      <React.Fragment>
        {previousLoading ? (
          <div
            style={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <CircularProgress size={60} className={classes.loader} />
          </div>
        ) : (
          <div className={classes.marqueeViewport} ref={this.viewportRef}>
            <div className={classes.marqueeAnimated} ref={this.marqueeRef}>
              <div ref={this.innerRef} className={classes.marqueeList}>
                {shoutouts.map((shoutout, i) => (
                  <div key={i} className={classes.marqueeItem}>
                    <ShoutoutCard
                      shoutout={shoutout}
                      index={i}
                      nameStyle={this.state.nameStyle}
                      settings={this.props.data.settings}
                      event={this.props.event}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    )
  }
}

export default compose(
  connect(),
  withStyles(styles, { withTheme: true })
)(Shoutout)



// WEBPACK FOOTER //
// ./src/components/Template/Blocks/ScrollingShoutouts/index.jsx